const DEFAULT_SUBDIVISION = 8;

export const DEFAULT_CHORD_PLAY_STYLE = "strum-down";

export const chordPlayStyleOptions = [
  {
    id: "block",
    shortName: "block",
    displayName: "Strum - Block Chord",
    description: "All chord notes play together at the start of the bar.",
    type: "block",
  },
  {
    id: "strum-down",
    shortName: "strum-down",
    displayName: "Strum - Single Down Strum",
    description: "One relaxed downstroke across the chord.",
    type: "strum",
    subdivision: 8,
    strokes: [
      { direction: "down", step: 0, velocity: 1 },
    ],
  },
  {
    id: "arp-up",
    shortName: "arp-up",
    displayName: "Arp - Five Notes Up",
    description: "Five notes in an ascending pattern.",
    type: "arpeggio",
    subdivision: 8,
    notes: [0, 1, 2, 3, 4],
  },
  {
    id: "arp-outside-in",
    shortName: "arp-outside-in",
    displayName: "Arp - Outside In",
    description: "Alternates low and high notes while moving toward the center.",
    type: "arpeggio",
    subdivision: 8,
    notes: [0, -1, 1, -2, 2, -3],
  },
  {
    id: "arp-up-down",
    shortName: "arp-up-down",
    displayName: "Arp - Up and Back",
    description: "Ascends through the chord, then walks back down without repeating the endpoints.",
    type: "arpeggio",
    subdivision: 8,
    notes: [0, 1, 2, 3, 4, 3, 2, 1],
  },
  {
    id: "arp-down",
    shortName: "arp-down",
    displayName: "Arp - Five Notes Down",
    description: "Five notes in a descending pattern.",
    type: "arpeggio",
    subdivision: 8,
    notes: [-1, -2, -3, -4, -5],
  },
  {
    id: "arp-top-pedal",
    shortName: "arp-top-pedal",
    displayName: "Arp - Top Pedal",
    description: "Alternates rising lower notes with the highest chord note.",
    type: "arpeggio",
    subdivision: 8,
    notes: [0, -1, 1, -1, 2, -1, 3, -1],
  },
  {
    id: "arp-bass-pedal",
    shortName: "arp-bass-pedal",
    displayName: "Arp - Bass Pedal",
    description: "Alternates the lowest chord note with rising upper notes.",
    type: "arpeggio",
    subdivision: 8,
    notes: [0, 1, 0, 2, 0, 3, 0, 4],
  },
  {
    id: "arp-center-out",
    shortName: "arp-center-out",
    displayName: "Arp - Center Out",
    description: "Starts near the middle of the chord and expands outward.",
    type: "arpeggio",
    subdivision: 8,
    notes: [2, 3, 1, 4, 0, 5],
  },
  {
    id: "arp-down-up",
    shortName: "arp-down-up",
    displayName: "Arp - Down and Back",
    description: "Descends through the chord, then rises back through the middle notes.",
    type: "arpeggio",
    subdivision: 8,
    notes: [-1, -2, -3, -4, -5, 1, 2, 3],
  },
  {
    id: "arp-top-alternating",
    shortName: "arp-top-alternating",
    displayName: "Arp - Top Alternating",
    description: "Returns to the highest note between each lower chord tone.",
    type: "arpeggio",
    subdivision: 8,
    notes: [-1, 0, -1, 1, -1, 2, -1, 3],
  },
  {
    id: "arp-split-up",
    shortName: "arp-split-up",
    displayName: "Arp - Split Up",
    description: "Plays the even-position notes first, then fills in the remaining tones.",
    type: "arpeggio",
    subdivision: 8,
    notes: [0, 2, 4, 1, 3, 5],
  },
  {
    id: "strum-folk-lift",
    shortName: "strum-folk-lift",
    displayName: "Strum - Folk Lift",
    description: "Downstrokes on the strong beats with light upstrokes between.",
    type: "strum",
    subdivision: 8,
    strokes: [
      { direction: "down", step: 0, velocity: 0.88 },
      { direction: "down", step: 2, velocity: 0.88 },
      { direction: "up", step: 3, velocity: 0.88 },
      { direction: "up", step: 5, velocity: 0.88 },
      { direction: "down", step: 6, velocity: 0.88 },
      { direction: "up", step: 7, velocity: 0.88 },
    ],
  },
  {
    id: "strum-country-skip",
    shortName: "strum-country-skip",
    displayName: "Strum - Country Skip",
    description: "A steady country-style pattern with a skipped third beat.",
    type: "strum",
    subdivision: 8,
    strokes: [
      { direction: "down", step: 0, velocity: 0.9 },
      { direction: "down", step: 2, velocity: 0.9 },
      { direction: "up", step: 3, velocity: 0.9 },
      { direction: "down", step: 4, velocity: 0.9 },
      { direction: "up", step: 7, velocity: 0.9 },
    ],
  },
  {
    id: "strum-eighths",
    shortName: "strum-eighths",
    displayName: "Strum - Eighth Note Strums",
    description: "Alternating down and up strums across all eight eighth notes.",
    type: "strum",
    subdivision: 8,
    strokes: [
      { direction: "down", step: 0, velocity: 0.82 },
      { direction: "up", step: 1, velocity: 0.82 },
      { direction: "down", step: 2, velocity: 0.82 },
      { direction: "up", step: 3, velocity: 0.82 },
      { direction: "down", step: 4, velocity: 0.82 },
      { direction: "up", step: 5, velocity: 0.82 },
      { direction: "down", step: 6, velocity: 0.82 },
      { direction: "up", step: 7, velocity: 0.82 },
    ],
  },
  {
    id: "strum-steady-du",
    shortName: "strum-steady-du",
    displayName: "Strum - Steady Down Up",
    description: "A balanced down-up pattern on every eighth note.",
    type: "strum",
    subdivision: 8,
    strokes: [
      { direction: "down", step: 0, velocity: 0.92 },
      { direction: "up", step: 1, velocity: 0.74 },
      { direction: "down", step: 2, velocity: 0.82 },
      { direction: "up", step: 3, velocity: 0.78 },
      { direction: "down", step: 4, velocity: 0.92 },
      { direction: "up", step: 5, velocity: 0.74 },
      { direction: "down", step: 6, velocity: 0.82 },
      { direction: "up", step: 7, velocity: 0.78 },
    ],
  },
  {
    id: "strum-syncopated-pop",
    shortName: "strum-syncopated-pop",
    displayName: "Strum - Syncopated Pop",
    description: "A pop strum with sixteenth-note pushes around beats two and three.",
    type: "strum",
    subdivision: 16,
    strokes: [
      { direction: "down", step: 0, velocity: 0.94 },
      { direction: "up", step: 3, velocity: 0.72 },
      { direction: "down", step: 4, velocity: 0.84 },
      { direction: "up", step: 6, velocity: 0.78 },
      { direction: "down", step: 9, velocity: 0.88 },
      { direction: "up", step: 10, velocity: 0.76 },
      { direction: "up", step: 14, velocity: 0.78 },
    ],
  },
  {
    id: "strum-push-pull",
    shortName: "strum-push-pull",
    displayName: "Strum - Push Pull",
    description: "Paired down and up strokes with sixteenth-note anticipation.",
    type: "strum",
    subdivision: 16,
    strokes: [
      { direction: "down", step: 0, velocity: 0.96 },
      { direction: "down", step: 3, velocity: 0.76 },
      { direction: "up", step: 4, velocity: 0.74 },
      { direction: "up", step: 6, velocity: 0.78 },
      { direction: "down", step: 8, velocity: 0.92 },
      { direction: "down", step: 11, velocity: 0.76 },
      { direction: "up", step: 12, velocity: 0.74 },
      { direction: "up", step: 14, velocity: 0.78 },
    ],
  },
  {
    id: "strum-reggae-lift",
    shortName: "strum-reggae-lift",
    displayName: "Strum - Reggae Lift",
    description: "Light offbeat upstrokes with stronger accents on the back half.",
    type: "strum",
    subdivision: 16,
    strokes: [
      { direction: "down", step: 0, velocity: 0.88 },
      { direction: "up", step: 2, velocity: 0.72 },
      { direction: "up", step: 6, velocity: 0.78 },
      { direction: "down", step: 8, velocity: 0.92 },
      { direction: "up", step: 10, velocity: 0.72 },
      { direction: "down", step: 13, velocity: 0.86 },
      { direction: "up", step: 14, velocity: 0.78 },
    ],
  },
  {
    id: "strum-rolling-16th",
    shortName: "strum-rolling-16th",
    displayName: "Strum - Rolling Sixteenths",
    description: "A busier rolling strum with several sixteenth-note pickups.",
    type: "strum",
    subdivision: 16,
    strokes: [
      { direction: "down", step: 0, velocity: 0.96 },
      { direction: "down", step: 2, velocity: 0.72 },
      { direction: "up", step: 3, velocity: 0.68 },
      { direction: "up", step: 6, velocity: 0.78 },
      { direction: "down", step: 7, velocity: 0.82 },
      { direction: "down", step: 8, velocity: 0.92 },
      { direction: "up", step: 10, velocity: 0.74 },
      { direction: "down", step: 12, velocity: 0.86 },
      { direction: "up", step: 14, velocity: 0.78 },
    ],
  },
  {
    id: "strum-backbeat-push",
    shortName: "strum-backbeat-push",
    displayName: "Strum - Backbeat Push",
    description: "A syncopated groove with pushes before beats two and four.",
    type: "strum",
    subdivision: 16,
    strokes: [
      { direction: "down", step: 0, velocity: 0.9 },
      { direction: "up", step: 2, velocity: 0.7 },
      { direction: "down", step: 5, velocity: 0.86 },
      { direction: "up", step: 6, velocity: 0.74 },
      { direction: "down", step: 8, velocity: 0.92 },
      { direction: "up", step: 10, velocity: 0.72 },
      { direction: "down", step: 13, velocity: 0.86 },
      { direction: "up", step: 15, velocity: 0.74 },
    ],
  },
  {
    id: "strum-16th-groove",
    shortName: "strum-16th-groove",
    displayName: "Strum - Sixteenth Groove",
    description: "A dense sixteenth-note groove with quick alternating strokes.",
    type: "strum",
    subdivision: 16,
    strokes: [
      { direction: "down", step: 0, velocity: 0.94 },
      { direction: "up", step: 1, velocity: 0.66 },
      { direction: "down", step: 3, velocity: 0.78 },
      { direction: "up", step: 4, velocity: 0.7 },
      { direction: "down", step: 6, velocity: 0.84 },
      { direction: "up", step: 7, velocity: 0.72 },
      { direction: "down", step: 9, velocity: 0.9 },
      { direction: "up", step: 10, velocity: 0.72 },
      { direction: "down", step: 12, velocity: 0.86 },
      { direction: "up", step: 14, velocity: 0.78 },
    ],
  },
];

export const chordPlayStyles = chordPlayStyleOptions.map((option) => option.id);

export function getChordPlayStyle(playStyle) {
  const value = String(playStyle || "").trim();
  return chordPlayStyleOptions.find((option) => option.id === value) || null;
}

export function normalizeChordPlayStyle(playStyle) {
  return getChordPlayStyle(playStyle)?.id || DEFAULT_CHORD_PLAY_STYLE;
}

export function chordPlayStyleLabel(playStyle) {
  return getChordPlayStyle(normalizeChordPlayStyle(playStyle))?.displayName || DEFAULT_CHORD_PLAY_STYLE;
}

export function chordPlayStyleDescription(playStyle) {
  return getChordPlayStyle(normalizeChordPlayStyle(playStyle))?.description || "";
}

export function noteIndexForPlayStyle(index, noteCount) {
  const rawIndex = Number(index);
  if (!Number.isFinite(rawIndex) || noteCount <= 0) {
    return null;
  }

  const resolvedIndex = rawIndex < 0 ? noteCount + rawIndex : rawIndex;
  if (!Number.isInteger(resolvedIndex) || resolvedIndex < 0 || resolvedIndex >= noteCount) {
    return null;
  }

  return resolvedIndex;
}

export function stepToBeatOffset(step, subdivision = DEFAULT_SUBDIVISION) {
  const safeSubdivision = Number(subdivision) || DEFAULT_SUBDIVISION;
  return (Number(step) || 0) * (4 / safeSubdivision);
}
